<div class="sms-dialog-shell" [class.sms-dialog-danger]="danger">
  <header class="sms-dialog-header"
          [class.sms-header-teal]="headerStyle === 'teal' && !danger"
          [class.sms-header-inverse]="headerStyle === 'inverse' && !danger"
          [class.sms-header-danger]="danger">
    <div class="sms-dialog-title-block">
      <h2 class="sms-dialog-title">{{ title }}</h2>
      <p *ngIf="subtitle" class="sms-dialog-subtitle">{{ subtitle }}</p>
    </div>
    <button
      *ngIf="showClose"
      type="button"
      class="sms-dialog-close"
      aria-label="Close dialog"
      cdkFocusInitial
      (click)="onClose()">
      <i class="bi bi-x-lg"></i>
    </button>
  </header>

  <section class="sms-dialog-body">
    <ng-content select="[body]"></ng-content>
  </section>

  <footer class="sms-dialog-footer">
    <ng-content select="[footer]"></ng-content>
  </footer>
</div>
